import { Box, Typography } from '@mui/material'
import RichText from '@/src/components/common/RichText'

import { RouteGuideFact } from '@/src/types/seoSrpResult'

interface RouteGuideProps {
    title: string
    summary: string
    facts: RouteGuideFact[]
}

const RouteGuide: React.FC<RouteGuideProps> = ({ title, summary, facts }) => {
    return (
        <Box sx={{ mb: 3 }}>
            <Typography
                component="h2"
                variant="h6"
                sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.25rem' }, mb: 1 }}
            >
                {title}
            </Typography>
            <RichText html={summary} variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, mb: 2 }} />
            <Box>
                {facts.map((fact, index) => (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            py: 1.5,
                            borderBottom: index < facts.length - 1 ? 1 : 0,
                            borderColor: 'grey.200',
                            flexDirection: { xs: 'column', md: 'row' },
                            gap: { xs: 0.5, md: 0 }
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, color: 'text.primary', minWidth: { md: '160px' } }}
                        >
                            {fact.label}
                        </Typography>
                        <RichText
                            html={fact.value}
                            variant="body2"
                            sx={{ color: 'text.secondary', textAlign: { md: 'right' }, flex: 1 }}
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default RouteGuide
export type { RouteGuideProps }
